import React from 'react';
import { IconProps } from './types';

export const InsertTextIcon: React.FC<IconProps> = ({
  size = 24,
  strokeWidth = 2,
  primaryColor = 'currentColor',
  className,
  title,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={primaryColor}
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    role="img"
    aria-label={title}
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M3 7v-2h12v2" />
    <path d="M9 5v14" />
    <path d="M7 19h4" />
    <path d="M18 15l2 2h-5" />
    <path d="M18 19l2 -2" />
  </svg>
);
